<template>
  <v-container>
    <v-row justify="center" align="center" class="mt-5">
      <p class="text-h5 text-sm-h4 text-uppercase">contact</p>
    </v-row>
    <v-row justify="center" align="center">
        <p class="text-h6 text-sm-h5">お問い合わせ・SNS</p>
    </v-row>
    <v-row justify="center" class="text-center">
        <p class="text-subtitle-2 text-sm-subtitle-1">
            制作の依頼・ご相談（無料）などがありましたら、<br>
            以下フォームまたはDMでご相談ください。<br>
            (外部ページに遷移します)
        </p>
    </v-row>
    <v-row>
        <Card/>
    </v-row>
  </v-container>
</template>

<script>
import Card from "../components/contact/Card";

export default {
  components: {
    Card,
  },
};
</script>